module.exports = __webpack_public_path__ + "static/media/infoIcon.3dd5f38f.svg";